import i18next from 'i18next';
import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
const keyPrefix = 'delete_departments';

export const deleteDepartmentTranslation = i18next.getFixedT(null, namespace, keyPrefix);

export const useDeleteDepartmentTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    title: 'Удалить подразделение',
    confirm_title_one: 'Удаление подразделения',
    confirm_title_few: 'Удаление подразделений',
    confirm_title_many: 'Удаление подразделений',
    confirm_title_other: 'Удаление подразделений',
    confirm_description_one: 'Вы уверены, что хотите удалить подразделение {{departmentName}}?',
    confirm_description_few: 'Вы уверены что хотите удалить выбранные подразделения?',
    confirm_description_many: 'Вы уверены что хотите удалить выбранные подразделения?',
    confirm_description_other: 'Вы уверены что хотите удалить выбранные подразделения?',
    confirm_submit: 'Удалить',
    confirm_cancel: 'Отмена',
    toast_success: 'Подразделение удалено',
    toast_error: 'Не удалось удалить подразделение',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Delete department',
    confirm_title_one: 'Deleting department',
    confirm_title_other: 'Deleting departments',
    confirm_description_one: 'Are you sure you want to delete the {{departmentName}} department?',
    confirm_description_other: 'Are you sure you want to delete the selected departments?',
    confirm_submit: 'Delete',
    confirm_cancel: 'Cancel',
    toast_success: 'Department deleted',
    toast_error: 'Failed to delete department',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Eliminar subdivisión',
    confirm_title_one: 'Eliminación de subdivisión',
    confirm_title_other: 'Eliminación de subdivisiones',
    confirm_description_one: '¿Seguro que quieres eliminar la subdivisión {{departmentName}}?',
    confirm_description_other: '¿Seguro que quieres eliminar las subdivisiones seleccionadas?',
    confirm_submit: 'Eliminar',
    confirm_cancel: 'Cancelar',
    toast_success: 'Subdivisión eliminada',
    toast_error: 'No se pudo eliminar la subdivisión',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Excluir departamento',
    confirm_title_one: 'Exclusão de departamento',
    confirm_title_other: 'Exclusão de departamentos',
    confirm_description_one: 'Tem certeza de que deseja excluir o departamento {{departmentName}}?',
    confirm_description_other: 'Tem certeza de que deseja excluir os departamentos selecionados?',
    confirm_submit: 'Excluir',
    confirm_cancel: 'Cancelar',
    toast_success: 'Departamento excluído',
    toast_error: 'Falha ao excluir departamento',
  },
}) as Record<string, unknown>;
